module.exports = __webpack_public_path__ + "img/blog10.7575b445.jpg";